export const environment = {
  production: false,
  staging: false,
  env: 'dev',
  apiUrl: 'https://api-dev.obsidiam.com/v1/',
  apiUrlMoneyTable: 'https://api-dev.obsidiam.com',
  // apiUrl: 'https://api-project.obsidiam.com/v1/',
  // apiUrlMoneyTable: 'https://api-project.obsidiam.com',
  google_captcha: '6Lf6GtsUAAAAAIPch5vTm61smjxb4KAHkYns1haM',
  keyJwe : "0Ctlf3n1n4icr3_43Srct3P_s4wsr01d",
  jweUrls: {
    'updateDynamicParameter' : {
      url : '/obsidiam-api/obsicash-service/v1/dynamic-parameters/obtainDynamicParameter',
      jwe: true
    },
    'getParametersObsicash' : {
      url : '/obsidiam-api/obsicash-service/v1/parameters/',
      jwe: true
    },
    getCountries : {
      url : '/obsidiam-api/obsicash-service/v1/country',
      jwe: true
    }
  }
}; 

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
